import React, { useState } from "react";
import { Box, Typography, Grid, IconButton, Dialog, useMediaQuery, Container } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "react-image-lightbox/style.css";
import Lightbox from "react-image-lightbox";
import {
  backsidebackgrounddesktop,
  backsidebackgroundmobile,
  gardientline,
  masterlayout,
  bulletpoint,
} from "../../../assets";

const images = ["https://dprstorage.b-cdn.net/kolla/luxuria%20master%20layout%20wbg-01%20(1).png"];

const MasterLayout: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const isMobile = useMediaQuery("(max-width: 600px)");


  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: isMobile ? "auto" : "100vh",
        backgroundImage: isMobile ? `url(${backsidebackgroundmobile})` : `url(${backsidebackgrounddesktop})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        overflow: "hidden",
        px: { xs: 0, md: 2 },
      }}
    >
      <Box
        sx={{
          width: "100%",
          color: "white",
          py: { xs: 6, md: 4 },
          px: { xs: 1, md: 2 },        }}
      >
        <Container maxWidth="xl">

        <Box sx={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
          <Typography
            variant="h2"
            sx={{
              fontWeight: "600",
              fontSize: { xs: "24px" , md: "28px" },
              background: "linear-gradient(90deg, #bf742c, #fff8da, #c58038)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              display: "inline-block",
            }}
          >
          Master Layout
          </Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", my: 1, width: "100%" }}>
              <img src={gardientline} alt="Best apartments in Hyderabad by Kolla Group" style={{ width: "100%", maxWidth: "900px", marginRight: 0 }} />
            </Box>
          </Box>

        <Box sx={{display: "flex",  alignItems: "center",mt: 1,}}>
          <Typography
            variant="body1"
            sx={{ fontSize: isMobile ? "12px": "16px", maxWidth: "800px", fontFamily: "LEMON MILK", mx: "auto", lineHeight: 1.6, my: 1 , textAlign: "center", fontWeight: "300", color : "#d3d3d3", letterSpacing: 1, opacity: 0.8 }}
          >
            Every element at <b>Kolla Luxuria</b> is designed for seamless luxury & privacy, offering a perfect blend of nature, comfort & grandeur.          </Typography>
        </Box>
          
        {/* make it in a row wise in mobile view and all okay so now give me  */}
        <Box sx={{ position: "relative", display: "flex", justifyContent: "center", flexDirection : isMobile ? "column" : "row", alignItems: "center", mt: 1, mb: 1 }}>
        {/* make it as 60% */}

        {isMobile && <Box sx={{ width : isMobile ? "100%" : "60%", display: "flex", justifyContent: "center", alignItems: "center",}}>
          <Box sx={{ position: "relative", display: "flex", justifyContent: "center", mt: 1 , height: isMobile ?"250px" :"550px", width: "100%" }}>
            <img
              src={"https://dprstorage.b-cdn.net/kolla/luxuria%20master%20layout%20wbg-01%20(1).png"}
              alt="Best apartments in Hyderabad by Kolla Group"
              onClick={() => setIsOpen(true)}
              style={{
                cursor: "pointer",
                height: "100%",
                borderRadius: 8,
                transition: "transform 0.3s",
              }}
            />
          </Box>
        </Box>}

        <Box sx={{ width: isMobile ? "100%" : "40%", display: "flex", justifyContent: "center", alignItems: "flex-start" }}>
          {!isMobile ? (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
              {[
          "One Apartment Per Floor – Exclusivity Privacy",
          "Designer Landscapes & Lush Green Spaces",
          "Dedicated Leisure & Recreation Zones",
          "Spacious Driveways & Ample Parking",
              ].map((feature, index) => (
          <Box key={index} sx={{ display: "flex", alignItems: "center", mb: 1, mt: 4 }}>
            <img src={bulletpoint} alt="Best apartments in Hyderabad by Kolla Group" style={{ width: "30px", height: "30px", marginRight: "8px" }} />
            <Typography
              variant="body1"
              sx={{
                fontSize: "16px",
                fontFamily: 'LEMON MILK',
                fontWeight: "400",
                color: "#d3d3d3",
                letterSpacing: 1,
              }}
            >
              {feature}
            </Typography>
          </Box>
              ))}
            </Box>
          ) : (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", my: 6 }}>
            {/* First Row: 3 Items with 2 Bullet Points */}
            <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "9px",
                  fontFamily: "LEMON MILK",
                  fontWeight: "400",
                  color: "#d3d3d3",
                  textAlign: "center",
                  letterSpacing: 1,
                }}
              >
                One Apartment Per Floor – Exclusivity Privacy
              </Typography>
              <img src={bulletpoint} alt="Best apartments in Hyderabad by Kolla Group" style={{ width: "20px", height: "20px" }} />
              <Typography
                variant="body1"
                sx={{
                  fontSize: "9px",
                  fontFamily: "LEMON MILK",
                  fontWeight: "400",
                  color: "#d3d3d3",
                  textAlign: "center",
                  letterSpacing: 1,
                }}
              >
                Four-Sided Open Design for Maximum Ventilation & Light
              </Typography>
            </Box>
          
            {/* Spacing Between Rows */}
            <Box sx={{ width: "100%", height: "16px" }} />
          
            {/* Second Row: 2 Items with 1 Bullet Point */}
            <Box sx={{ display: "flex", alignItems: "center", gap: "2px" }}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "9px",
                  fontFamily: "LEMON MILK",
                  fontWeight: "400",
                  color: "#d3d3d3",
                  textAlign: "center",
                  letterSpacing: 1,
                }}
              >
                Designer Landscapes &   <br /> Lush Green Spaces
              </Typography>
              <img src={bulletpoint} alt="Best apartments in Hyderabad by Kolla Group" style={{ width: "20px", height: "20px" }} />
              <Typography
                variant="body1"
                sx={{
                  fontSize: "9px",
                  fontFamily: "LEMON MILK",
                  fontWeight: "400",
                  color: "#d3d3d3",
                  textAlign: "center",
                  letterSpacing: 1,
                }}
              >
                Dedicated Leisure & <br />Recreation Zones
              </Typography>
              {/* <img src={bulletpoint} alt="Bullet Point" style={{ width: "20px", height: "20px" }} />
              <Typography
                variant="body1"
                sx={{
                  fontSize: "9px",
                  fontFamily: "LEMON MILK",
                  fontWeight: "400",
                  color: "#d3d3d3",
                  textAlign: "center",
                  letterSpacing: 1,
                }}
              >
                Spacious Driveways & Ample Parking
              </Typography> */}
            </Box>
          </Box>          
          )}
        </Box>

        
        {!isMobile && <Box sx={{ width : isMobile ? "100%" : "60%", display: "flex", justifyContent: "center", alignItems: "center",}}>
          <Box sx={{ position: "relative", display: "flex", justifyContent: "center", mt: 1 , height: isMobile ?"300px" :"550px", width: "100%" }}>
            <img
              src={"https://dprstorage.b-cdn.net/kolla/luxuria%20master%20layout%20wbg-01%20(1).png"}
              alt="Best apartments in Hyderabad by Kolla Group"
              onClick={() => setIsOpen(true)}
              style={{
                cursor: "pointer",
                height: "100%",
                borderRadius: 8,
                transition: "transform 0.3s",
              }}
            />
          </Box>
        </Box>
        }


        </Box>

      </Container>

      {/* Lightbox Modal */}
      {isOpen && (
        <Lightbox
          mainSrc={images[photoIndex]}
          nextSrc={images[(photoIndex + 1) % images.length]}
          prevSrc={images[(photoIndex + images.length - 1) % images.length]}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() => setPhotoIndex((photoIndex + images.length - 1) % images.length)}
          onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % images.length)}
        />
      )}
    </Box>
  </Box>

  );
};

export default MasterLayout;
















